var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-div"},[_c('a-spin',{attrs:{"tip":"加载中..."}},[_c('a-icon',{staticStyle:{"font-size":"5vh"},attrs:{"slot":"indicator","type":"loading","spin":"","size":"large"},slot:"indicator"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }